import { createUseStyles } from 'react-jss'

export default createUseStyles({
  container: {
    minWidth: 120,
    padding: '10px 14px',
    display: 'flex',
    flexDirection: 'column',
    rowGap: 4
  },
  statusChip: {
    display: 'inline-block'
  }
})
